import React from 'react';
import nayaritMapDefault from "../../../Styles/imagenes/nayarit-map-green.png";

// ─── Colores de estado ─────────────────────────────────────────────────────────
const GREEN    = "#27762F";
const YELLOW   = "#a98000";
const CRITICAL = "#bd413f";
const BLUE     = "#3275b4";

function statusOf(pct) {
    if (pct >= 100) return { label: "Excedente", color: BLUE     };
    if (pct >= 60)  return { label: "Óptimo",    color: GREEN    };
    if (pct >= 30)  return { label: "Moderado",  color: YELLOW   };
    return               { label: "Crítico",    color: CRITICAL };
}

// ─── Posiciones de pines sobre el mapa de Nayarit ─────────────────────────────
// Ajustar top/left según posición exacta en el PNG
const PIN_POSITIONS = [
    { key: "aguamilpa",         top: 110, left: 62 },
    // { key: "layesca",        top: 120, left: 30 },  // omitida — ya no existe
    { key: "leonardorodriguez", top: 115, left: 85 },
    { key: "sanrafael",         top: 125, left: 65 },
];

const PresasNayaritNuevoDiseno = ({
    presas,
    mapSrc = nayaritMapDefault,
    presaSeleccionada,
    presaHovered,
    onPresaSelect,
    onPresaHover,
}) => {
    if (!presas) return null;

    // Pines con color dinámico
    const pins = PIN_POSITIONS.map(({ key, top, left }) => {
        const presa = presas[key];
        const pct   = presa?.porcentaje ?? 0;
        const { color } = statusOf(pct);
        return { key, top, left, color };
    });

    // Leyenda: todas las claves excepto "total" y "layesca", ordenadas por porcentaje desc
    const leyenda = Object.entries(presas)
        .filter(([key]) => key !== "total" && key !== "layesca")
        .map(([key, presa]) => {
            const pct = presa?.porcentaje ?? 0;
            const { color } = statusOf(pct);
            return {
                key,
                name:  presa?.presa || key,
                pct:   parseFloat(pct).toFixed(1).replace(/\.0$/, ""),
                color,
            };
        })
        .sort((a, b) => parseFloat(b.pct) - parseFloat(a.pct));

    return (
        <div className="presas-body">
            {/* Mapa con pines interactivos */}
            <div className="presas-map-container">
                <img src={mapSrc} alt="Mapa de Nayarit" className="presas-map-image" />
                {pins.map((p) => (
                    <div
                        key={p.key}
                        className={[
                            'presas-pin',
                            presaHovered     === p.key ? 'presas-pin--hovered'  : '',
                            presaSeleccionada === p.key ? 'presas-pin--selected' : '',
                        ].filter(Boolean).join(' ')}
                        style={{ top: p.top, left: p.left, background: p.color }}
                        onClick={() => onPresaSelect?.(p.key)}
                        onMouseEnter={() => onPresaHover?.(p.key)}
                        onMouseLeave={() => onPresaHover?.(null)}
                    />
                ))}
            </div>

            {/* Leyenda interactiva */}
            <div className="presas-legend">
                {leyenda.map((d) => (
                    <div
                        key={d.key}
                        className={[
                            'presas-legend-row',
                            presaHovered     === d.key ? 'presas-legend-row--hovered'  : '',
                            presaSeleccionada === d.key ? 'presas-legend-row--selected' : '',
                        ].filter(Boolean).join(' ')}
                        onClick={() => onPresaSelect?.(d.key)}
                        onMouseEnter={() => onPresaHover?.(d.key)}
                        onMouseLeave={() => onPresaHover?.(null)}
                    >
                        <span className="presas-legend-dot" style={{ background: d.color }} />
                        <span className="presas-legend-name">{d.name}</span>
                        <span className="presas-legend-pct" style={{ color: d.color }}>{d.pct}%</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PresasNayaritNuevoDiseno;
